import { DialogModule } from '@angular/cdk/dialog';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router, RouterLink } from '@angular/router';
import { ConvertToSlugPipe } from 'app/shared/convert-to-slug.pipe';
import { SharedModule } from 'app/shared/shared.module';
import { VideosEducatives } from 'app/shared/VideosEducatives';
interface Video {
  id: string;
}

const VIDEOS: Video[] = [
  {
    id: 'gb3biuvkqh4g',
  },
  {
    id: 'bw2xi7dag4fw',
  },
  {
    id: 'rv8h6keuj7wt',
  },
  {
    id: 'pghqcv8eeucv',
  },
];
@Component({
  selector: 'app-youtube-player',
  templateUrl: './youtube-player.component.html',
  styleUrls: ['./youtube-player.component.css'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    MatButtonModule,
    DialogModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatTooltipModule,
    SharedModule,
    RouterLink,
    ConvertToSlugPipe,
  ],
})
export class YoutubePlayerComponent {
  @ViewChild('demoYouTubePlayer') demoYouTubePlayer: ElementRef<HTMLDivElement>;
  videos = VIDEOS;
  videoWidth: number | undefined;
  videoHeight: number | undefined;
  apiLoaded = false;
  videoId = 'bw2xi7dag4fw';
  selectedVideo: string = 'https://streamyard.com/e/bw2xi7dag4fw';
  videosEducatives = VideosEducatives;
}
